import { COUNRTY_DATA_WITH_CALLING_CODE } from "../config/urls";
import { _setCountryData } from "../redux/reducers/setting";

export const CountryDataWithCountryCode = (dispatch)=>{
    fetch(COUNRTY_DATA_WITH_CALLING_CODE)
    .then((res) => res.json())
    .then((data) => {
        dispatch(_setCountryData(data))
    })
    .catch((err) => console.log(err));
}